import { Collapse } from '@mui/material'
import React, { useState } from 'react'

const Steps = ({ currentStep, type, disableSteps, handleStepClick }) => {
  const { bookingData, modifyData } = window
  const steps =
    (bookingData && bookingData.steps) || (modifyData && modifyData.steps)

  const { dictionary } = bookingData || modifyData

  const [showMobileSteps, setShowMobileSteps] = useState(false)

  const getStepClassName = (index) => {
    return `b-step ${
      index === currentStep
        ? 'b-step--active'
        : index < currentStep
        ? 'b-step--completed'
        : ''
    } ${disableSteps ? 'disabled' : ''}`
  }

  const onHandleStepClick = (step, index) => {
    setShowMobileSteps(false)
    if (!disableSteps) handleStepClick(step, index)
  }

  return (
    <div className="s-steps">
      <div className="page-container">
        <div className="s-steps__steps">
          {steps.map((step, index) => (
            <div
              className={getStepClassName(index)}
              key={index}
              onClick={() => onHandleStepClick(step, index)}>
              <span className="b-step__num">{index + 1}</span>
              <i className={step.icon}></i>
              <span className="b-step__txt">
                {type === 'modify' && index == 2
                  ? `${step.title} ${dictionary.modification}`
                  : type === 'cancel' && index == 2
                  ? `${step.title} ${dictionary.cancelation}`
                  : step.title}
              </span>
            </div>
          ))}
        </div>

        <div
          className="s-steps__steps--devices "
          onClick={() => setShowMobileSteps(!showMobileSteps)}>
          <div className="s-steps__step-num">
            <span>
              {currentStep + 1} / {steps.length}
            </span>
            <span>{steps[currentStep]?.title}</span>
          </div>
          <i className="icon-arrow-dropdown-down"></i>
        </div>

        <div className="s-steps__mobile-steps">
          <Collapse in={showMobileSteps}>
            <div className="s-steps__mobile-steps__wrapper">
              <div className="s-steps__mobile-steps__header">
                <span>{dictionary.mobileStepsTitle}</span>
                <i
                  className="icon-x"
                  onClick={() => setShowMobileSteps(false)}></i>
              </div>
              <div className="s-steps__mobile-steps__content">
                {steps.map((step, index) => (
                  <div
                    className={getStepClassName(index)}
                    key={index}
                    onClick={() => onHandleStepClick(step, index)}>
                    {currentStep > index ? (
                      <i className="icon-check"></i>
                    ) : (
                      <span className="b-step__num">{index + 1}</span>
                    )}
                    <span className="b-step__txt">{step.title}</span>
                  </div>
                ))}
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  )
}

export default Steps
